/**
 * API Client Module
 * Handles authenticated HTTP requests to the backend API
 */

let TOKEN = null;
let API_BASE = '';

/**
 * Get the API base URL
 * @returns {string} API base URL
 */
export function getAPIBase() {
    if (!API_BASE) {
        API_BASE = window.location.origin;
    }
    return API_BASE;
}

/**
 * Set authentication token
 * @param {string} token - JWT authentication token
 */
export function setToken(token) {
    TOKEN = token;
    if (token) {
        sessionStorage.setItem('access_token', token);
    }
}

/**
 * Get current authentication token
 * @returns {string|null} Current token or null
 */
export function getToken() {
    if (!TOKEN) {
        TOKEN = sessionStorage.getItem('access_token');
    }
    return TOKEN;
}

/**
 * Perform authenticated fetch request
 * @param {string} url - Request URL
 * @param {RequestInit} [options={}] - Fetch options
 * @returns {Promise<Response>} Fetch response
 */
export async function secureFetch(url, options = {}) {
    if (!TOKEN) TOKEN = sessionStorage.getItem('access_token');
    if (!TOKEN) {
        window.location.href = 'index.php';
        return;
    }

    options.headers = {
        ...options.headers,
        'Authorization': `Bearer ${TOKEN}`
    };

    if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(options.body);
    }

    const res = await fetch(url, options);

    if (res.status === 401) {
        console.warn('Session expired');
        sessionStorage.clear();
        window.location.href = 'index.php';
        return;
    }

    return res;
}
